/**
 * Turn chat / graph log JSON into a flat dict for {@link evaluateCondition}.
 *
 * Backend {@code transition_ctx} is flat (L3 counters + L4 fields + current_state, …).
 * Message logs expose {@code parameter_changes: { l3: {before, after}, l4: {before, after} }}.
 *
 * @param {unknown} raw
 * @param {{ phase?: 'after' | 'before' }} [opts] Which snapshot to use for nested l3/l4 (default {@code 'after'}).
 * @returns {Record<string, unknown>}
 */
export function normalizeConditionPreviewParams(raw, opts = {}) {
  const phase = opts.phase === 'before' ? 'before' : 'after'
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return {}
  }

  if (raw.condition_preview && typeof raw.condition_preview === 'object') {
    const snap = raw.condition_preview.at_allow_offer
    if (snap && typeof snap === 'object' && !Array.isArray(snap)) {
      return { ...snap }
    }
  }

  const root =
    'parameter_changes' in raw &&
    raw.parameter_changes &&
    typeof raw.parameter_changes === 'object' &&
    !Array.isArray(raw.parameter_changes)
      ? raw.parameter_changes
      : raw

  const pick = (block) => {
    if (!block || typeof block !== 'object') return {}
    const snap = block[phase] ?? block.after ?? block.before
    return snap && typeof snap === 'object' && !Array.isArray(snap) ? { ...snap } : {}
  }

  const l3 = pick(root.l3)
  const l4 = pick(root.l4)

  if (Object.keys(l3).length > 0 || Object.keys(l4).length > 0) {
    const merged = { ...l3, ...l4 }
    for (const [k, v] of Object.entries(raw)) {
      if (k === 'parameter_changes' || k === 'l3' || k === 'l4') continue
      if (v !== null && typeof v !== 'object' && !Array.isArray(v)) {
        merged[k] = v
      }
    }
    return merged
  }

  return { ...raw }
}
